import { useRef } from "react";

export const useAbortController = () => {
  const controllerRef = useRef(null);

  const getSignal = () => {
    if(controllerRef.current){

        controllerRef.current?.abort();
    }
    controllerRef.current = new AbortController();
    return controllerRef.current.signal;
  };

  const abort = () => {
    controllerRef.current?.abort();
  };

  return { getSignal, abort };
};
